import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { AnalyticsLoaderService } from './core/services/analytics-loader.service';
import { AuthService } from './core/services/auth.service';
import { DesignService } from './core/services/design.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'CitizeX';

  headerStyle: string;
  headerStyleSubscription: any;

  // loggedInUser used to get cookie details
  private loggedInUser: any;
  public showSideBar = false;
  public isLandingPage = false;
  public isPublicAuthPage = false;
  public isPublicContentPage = false;
  public isPublicShellPage = false;
  public isIdentityVerificationHandoff = false;

  public getUserLoggedIn(): boolean {
    return this.authService.getLogflag();
  }

  constructor(
    private authService: AuthService,
    private cookieService: CookieService,
    private router: Router,
    private designService: DesignService,
    private analyticsLoaderService: AnalyticsLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.headerStyle = designService.headerStyle;
    this.headerStyleSubscription =
      this.designService.headerStyleChange.subscribe((value) => {
        this.headerStyle = value;
      });

    // The bootstrap refresh restores an active session before this component
    // is constructed, so a signed-in visitor to the public home returns to
    // their portal. The NavigationEnd handler covers legacy-route redirects.
    this.redirectAuthenticatedHome(window.location.pathname);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;
        if (!this.redirectAuthenticatedHome(url.split(/[?#]/, 1)[0])) {
          this.updateRouteLayout(url);
        }
      }
    });
    this.updateRouteLayout(this.router.url, false);

    // this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    //     this.clearModals();
    //   }
    // });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // delay cleanup so Bootstrap animations don't conflict
        setTimeout(() => {
          this.clearModals();
        }, 0);
      }
    });
  }

  private clearModals(): void {
    // Remove backdrops
    document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());

    // Reset body state
    document.body.classList.remove('modal-open');
    document.body.style.removeProperty('padding-right');

    // Force-hide any stuck modals
    document.querySelectorAll('.modal').forEach((modal: any) => {
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    });
  }

  ngOnInit(): void {
    this.analyticsLoaderService.init();

    const loader = document.getElementById('app-loader');
    if (loader) {
      loader.style.transition = 'opacity 0.3s ease';
      loader.style.opacity = '0';
      setTimeout(() => (loader.style.display = 'none'), 300);
    }
  }

  private updateRouteLayout(url: string, detectChanges = true): void {
    const requestedPath = url.split(/[?#]/, 1)[0];
    const path = requestedPath.replace(/\/+$/, '') || '/';
    this.isLandingPage = path === '/';
    this.isPublicAuthPage =
      path === '/login' ||
      path === '/signup' ||
      path === '/thankyou' ||
      path === '/forgotPassword' ||
      path === '/trouble-signing-up' ||
      path === '/request-demo' ||
      path.startsWith('/resetPassword/');
    this.isPublicContentPage =
      path === '/events' ||
      path === '/posts' ||
      path === '/polls' ||
      path === '/announcements' ||
      path === '/representatives' ||
      path.startsWith('/profile/view-response/') ||
      path.startsWith('/profile/view-virtual-event/');
    this.isPublicShellPage =
      this.isLandingPage ||
      this.isPublicAuthPage ||
      (this.isPublicContentPage && !this.authService.getLogflag()) ||
      path === '/get-started' ||
      path === '/upcoming-virtual-townhall' ||
      path === '/about-us' ||
      path === '/privacy-and-policy' ||
      path === '/terms-and-conditions' ||
      path === '/child-safety-policy' ||
      path === '/deleteAccount' ||
      path.startsWith('/unsubscribe/');
    this.isIdentityVerificationHandoff =
      path === '/identity-verification/complete';
    if (detectChanges) {
      this.cdr.detectChanges();
    }
  }

  private redirectAuthenticatedHome(path: string): boolean {
    if (path !== '/' || !this.authService.getLogflag()) {
      return false;
    }

    const user = this.authService.getUser();
    if (!user) {
      return false;
    }

    const destination =
      !user.isTourDone && user.defaultProfileTagName
        ? '/profile/view-profile/' + user.defaultProfileTagName
        : '/portal';

    this.router.navigateByUrl(destination, { replaceUrl: true });
    return true;
  }
}
